import ApiService from './api.service';

const UsuarioService = {
	authenticate: async () => {
		const response = await ApiService.get('/api/authenticate');
		return response.data;
	},
	getUser: async () => {
		const response = await ApiService.get('/api/account');
		return response.data;
	}
};

export default UsuarioService;
